import { Component,  EventEmitter,  OnInit } from "@angular/core";
import { CatalogDataQuality } from "../../Model/validation/CatalogDataQuality";
import { ModelService } from "../../Services/model.service";
import { Message } from "../../Model/System/Message";
import { StartAction } from "../../Model/Dto/StartAction";
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from "../../Services/userManagment.service";
import { ValidationMethod } from "../../Model/validation/ValidationMethod";
import { ValidationService } from "../../Services/Validation/validation.service";
import { CatalogService } from "../../Services/CatalogManagement/catalog.service";

@Component({
  selector: "dataQuality",
  templateUrl: "dataQuality.component.html",
  styleUrls: []
})
export class DataQualityComponent implements OnInit { 

  pages = [];
  chartText: string="";
  informationenText: string = "";
  exampleText: string = "";
  groupsText: string = "";
  statisticText: string = "";

  model: CatalogDataQuality[];
  validationMethods: ValidationMethod[];
  selectedValidationMethod: ValidationMethod;
  modelChangedEvent: EventEmitter<CatalogDataQuality> = new EventEmitter<CatalogDataQuality>();

  constructor(public modelService: ModelService, public translate: TranslateService, public catalogService: CatalogService, public userManagement: UserManagementService, public validationService: ValidationService) {
    this.calculate = this.calculate.bind(this);
    this.reload = this.reload.bind(this);
  }

  ngOnInit(): void {

    this.chartText = this.translate.instant("Qualität");
    this.groupsText = this.translate.instant("Gruppen");
    this.statisticText = this.translate.instant("Statistik");
    this.informationenText = this.translate.instant("Informationen");
    this.exampleText = this.translate.instant("Beispiele");


    this.pages = [
        { id: 1, title: this.chartText, template: "chartTemplate" },
        { id: 4, title: this.groupsText, template: "groupsTemplate" },
        { id: 5, title: this.statisticText, template: "statisticTemplate" },
        { id: 2, title: this.informationenText, template: "factsTemplate" }
    ];

    this.validationService.getValidationMethods().subscribe(validationMethods => {
      this.validationMethods = validationMethods;
      this.selectedValidationMethod = this.validationMethods.find(x => x.id == this.modelService.catalogService.catalog.validationMethodId);
      if (this.selectedValidationMethod == undefined) {
        this.selectedValidationMethod = this.validationMethods.find(x => x.isDefault && !x.isGlobal);
        if (this.selectedValidationMethod == undefined) {
          this.selectedValidationMethod = this.validationMethods.find(x => x.isDefault);
        }
      }
    });
  }

  calculate() {
    let param = new StartAction();
    param.customerId = this.modelService.loginService.currentUser.customerId;
    param.catalogId = this.modelService.catalogService.selectedCatalogId;

    this.modelService.dataQualityService.CalculateCatalogDataQuality(param).subscribe(
      () => {
        this.translate.get("Berechnung wurde als Job gestartet").subscribe((text: string) => {
          this.modelService.systemService.notify(new Message(text));
        });
      }
    );
  }

  reload() {
    this.modelService.dataQualityService.getDataQuality(this.modelService.loginService.currentUser.customerId, this.modelService.catalogService.selectedCatalogId).subscribe(
      (result: CatalogDataQuality) => {
        result.catalog = this.modelService.catalogService.catalog.catalogName;
        this.model = new Array<CatalogDataQuality>();
        this.model.push(result);
        this.modelService.dataQualityService.catalogDataQuality = result;
        this.modelChangedEvent.emit(result);
      }
    );
  }

  canView(name: string): boolean {
    return this.userManagement.canView(name);
  }
  readOnlyUser(name: string): boolean {
    return !this.userManagement.canEdit(name);
  }

  validationMethodChanged() {
    this.catalogService.catalog.validationMethodId = this.selectedValidationMethod.id;
    this.catalogService.updateCatalog().finally(() => this.reload());
  }

}
